module.exports = __webpack_public_path__ + "static/media/halfglove.6154b82d.png";